import { render, staticRenderFns } from "./ArabicContractShaqlawaView.vue?vue&type=template&id=0bec5184&scoped=true&"
import script from "./ArabicContractShaqlawaView.vue?vue&type=script&lang=js&"
export * from "./ArabicContractShaqlawaView.vue?vue&type=script&lang=js&"
import style0 from "./ArabicContractShaqlawaView.vue?vue&type=style&index=0&id=0bec5184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bec5184",
  null
  
)

export default component.exports